module.exports = __webpack_public_path__ + "img/check.d87935b3.svg";